import type { OnHandCatalogHistoryItem } from '~/types/entities/onHandCatalog'

import useGetInStockAmount from '../orders-and-receives/order-item-receipts/hooks/useGetInStockAmount'

const AdjustedQuantityCell = (item: OnHandCatalogHistoryItem) => {
  const getInStockAmount = useGetInStockAmount({
    relative: true,
  })

  return (
    <>
      {getInStockAmount({
        amount: item.quantity,
        amountUnitsId: item.quantityUnitId,
        perPackageUnitsId: item.perPackageUnitsId,
        packageTypeId: item.packageTypeId,
      })}
    </>
  )
}

export default AdjustedQuantityCell
